"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlertColor = getAlertColor;
exports.getAlertTypeName = getAlertTypeName;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var TEXT = {
  ADTALERT: 'ADT'
};
var COLOR = {
  ADTALERT: 'blue',
  HEDIS: 'red'
};
var DEFAULT_COLOR = 'orange';
function getAlertTypeName(alertType) {
  var _TEXT$alertType;
  return (_TEXT$alertType = TEXT[alertType]) !== null && _TEXT$alertType !== void 0 ? _TEXT$alertType : alertType;
}
function getAlertColor(alertType) {
  var _COLOR$alertType;
  return (_COLOR$alertType = COLOR[alertType]) !== null && _COLOR$alertType !== void 0 ? _COLOR$alertType : DEFAULT_COLOR;
}
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(TEXT, "TEXT", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/alert-mapping.js");
  reactHotLoader.register(COLOR, "COLOR", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/alert-mapping.js");
  reactHotLoader.register(DEFAULT_COLOR, "DEFAULT_COLOR", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/alert-mapping.js");
  reactHotLoader.register(getAlertTypeName, "getAlertTypeName", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/alert-mapping.js");
  reactHotLoader.register(getAlertColor, "getAlertColor", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/alert-mapping.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJURVhUIiwiQURUQUxFUlQiLCJDT0xPUiIsIkhFRElTIiwiREVGQVVMVF9DT0xPUiIsImdldEFsZXJ0VHlwZU5hbWUiLCJhbGVydFR5cGUiLCJnZXRBbGVydENvbG9yIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbW1vbi9hbGVydC1tYXBwaW5nLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFRFWFQgPSB7XG5cdEFEVEFMRVJUOiAnQURUJyxcbn07XG5cbmNvbnN0IENPTE9SID0ge1xuXHRBRFRBTEVSVDogJ2JsdWUnLFxuXHRIRURJUzogJ3JlZCcsXG59O1xuXG5jb25zdCBERUZBVUxUX0NPTE9SID0gJ29yYW5nZSc7XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRBbGVydFR5cGVOYW1lKGFsZXJ0VHlwZSkge1xuXHRyZXR1cm4gVEVYVFthbGVydFR5cGVdID8/IGFsZXJ0VHlwZTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGdldEFsZXJ0Q29sb3IoYWxlcnRUeXBlKSB7XG5cdHJldHVybiBDT0xPUlthbGVydFR5cGVdID8/IERFRkFVTFRfQ09MT1I7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUEsSUFBTUEsSUFBSSxHQUFHO0VBQ1pDLFFBQVEsRUFBRTtBQUNYLENBQUM7QUFFRCxJQUFNQyxLQUFLLEdBQUc7RUFDYkQsUUFBUSxFQUFFLE1BQU07RUFDaEJFLEtBQUssRUFBRTtBQUNSLENBQUM7QUFFRCxJQUFNQyxhQUFhLEdBQUcsUUFBUTtBQUV2QixTQUFTQyxnQkFBZ0IsQ0FBQ0MsU0FBUyxFQUFFO0VBQUE7RUFDM0MsMEJBQU9OLElBQUksQ0FBQ00sU0FBUyxDQUFDLDZEQUFJQSxTQUFTO0FBQ3BDO0FBRU8sU0FBU0MsYUFBYSxDQUFDRCxTQUFTLEVBQUU7RUFBQTtFQUN4QywyQkFBT0osS0FBSyxDQUFDSSxTQUFTLENBQUMsK0RBQUlGLGFBQWE7QUFDekM7QUFBQztBQUFBO0VBQUE7RUFBQTtJQUFBO0VBQUE7RUFBQSx3QkFqQktKLElBQUk7RUFBQSx3QkFJSkUsS0FBSztFQUFBLHdCQUtMRSxhQUFhO0VBQUEsd0JBRUhDLGdCQUFnQjtFQUFBLHdCQUloQkUsYUFBYTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7QUFBQSJ9